<template>
  <v-list-item :class="['px-0', item_class]">
    <v-list-item-avatar size="20" class="my-0">
      <v-avatar :color="status_color" size="20">
        <v-icon v-if="is_complete" color="white" size="18">
          mdi-check
        </v-icon>
        <span v-else class="white--text font-weight-bold text-body-2">{{ step_number }}</span>
      </v-avatar>
    </v-list-item-avatar>
    
    <v-list-item-content class="py-2">
      <div class="d-flex align-center mb-0">
        <v-list-item-title class="font-weight-medium text-body-2">
          <slot name="title">{{ title }}</slot>

          <div v-if="show_publish_warning_count" class="d-flex align-center justify-space-between">
            <strong class="text-caption error--text font-weight-bold">
              {{ validation_warnings.length }} issue{{
                validation_warnings.length === 1 ? '' : 's'
              }}
              preventing publish
            </strong>
          </div>
        </v-list-item-title>

        <v-tooltip v-if="tooltip" bottom max-width="300">
          <template #activator="{ on, attrs }">
            <v-icon
              small
              color="grey"
              class="ml-1"
              v-bind="attrs"
              v-on="on"
            >
              mdi-help-circle-outline
            </v-icon>
          </template>
          <span>{{ tooltip }}</span>
        </v-tooltip>
      </div>

      <v-alert
        v-if="validation_warnings.length > 0"
        class="shaded mt-2 mb-0"
        dense
      >
        <ul class="pl-5 validation-list">
          <li v-for="(warning, i) in validation_warnings" :key="i">
            <div class="d-flex justify-space-between align-center">
              <div class="d-flex align-start">
                <v-icon size="18" :color="alert_icon_color" aria-hidden="true" class="mr-1">
                  {{ alert_icon }}
                </v-icon>
                <span class="text-body-2">{{ warning.text }}</span>
              </div>
              <v-btn
                v-if="$listeners['fix-warning']"
                :color="alert_button_color"
                class="ml-3 flex-shrink-0"
                small
                text
                @click="handleWarningAction(warning)"
              >
                {{ warning.action_button_text || 'Fix It' }}
              </v-btn>
            </div>
          </li>
        </ul>
      </v-alert>

      <slot name="alert" />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'WidgetEditorChecklistItem',

  props: {
    step_number: {
      type: [Number, String],
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    is_complete: {
      type: Boolean,
      default: false,
    },
    status_color: {
      type: String,
      default: 'grey',
    },
    /**
     * Corresponds to warnings created by the guided validation mixin
     */
    validation_warnings: {
      type: Array,
      default: () => [],
    },
    alert_icon: {
      type: String,
      default: 'mdi-alert-circle',
    },
    alert_icon_color: {
      type: String,
      default: 'error',
    },
    alert_button_color: {
      type: String,
      default: 'error',
    },
    item_class: {
      type: String,
      default: '',
    },
    is_publish_step: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    show_publish_warning_count() {
      return this.is_publish_step && this.validation_warnings.length > 0 && !this.$slots.title;
    },
  },

  methods: {
    handleWarningAction(warning) {
      if (warning.action) {
        warning.action();
      } else {
        this.$emit('fix-warning', warning);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.validation-list {
  list-style: none;
  padding-left: 0 !important;

  li:not(:last-child) {
    margin-bottom: 0.5rem;
  }
}
</style>
